<template>
  <div class="pc-date-wrapper">
    <input-label v-if="label">
      {{ fieldLabel }}
    </input-label>
    <div class="pc-date">
      <v-date-picker
        ref="datepicker"
        :masks="{input: 'DD.MM.YYYY'}"
        v-bind="{
          'is-required': true,
          popover: {
            visibility: 'focus',
          },
          ...vCalendarOptions
        }"
        :locale="$i18n.locale"
        :value="value"
        @input="emitInput"
      >
        <template #default="{inputValue, inputEvents}">
          <div class="date-input-wrap" v-on="inputEvents">
            <pc-text-input
              ref="input"
              class="pc-date__input"
              :value="inpValue"
              :placeholder="placeholder"
              :mask-options="maskOptions"
              :emit-input-as-event="true"
              :debounce-time="1"
              :hide-errors="true"
              :hide-hints="true"
              icon-name="pc-calendar"
              @focusin="isFieldInFocus = true"
              @focusout="focusOutHandler"
              @input="inputHandler"
              @keyup.native.enter="focusOutHandler"
            />
          </div>
        </template>
      </v-date-picker>
    </div>
    <input-error class="date-input__error">
      <template v-if="errorMessage">
        {{ $t(errorMessage) }}
      </template>
    </input-error>
    <template v-if="!errorMessage && isFieldInFocus">
      <slot name="hint">
        <input-hint v-if="hint" class="pc-date__hint">
          {{ hint }}
        </input-hint>
      </slot>
    </template>
  </div>
</template>

<script>
import InputError from '@/components/inputs/InputError.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputHint from '@/components/inputs/InputHint.vue'
import IcuIcon from '@/components/common/IcuIcon.vue'
import {format, parseISO} from 'date-fns'
import PcTextInput from '@/components/inputs/PcTextInput'
export default {
  name: 'PcDateInput',
  components: {PcTextInput, IcuIcon, InputHint, InputLabel, InputError },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    errors: {
      type: Array,
      default: null
    },
    vCalendarOptions: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      inpValue: null,
      isFieldInFocus: false,
      maskOptions: {
        mask: Date,
        lazy: true
      },
    }
  },
  computed: {
    fieldLabel() {
      if (this.required) {
        return `${this.label} *`
      }

      return this.label
    },
    errorMessage() {
      return this.errors?.[0] || ''
    }
  },
  watch:{
    value: {
      handler(value) {
        if(value) {
          this.inpValue = value ? format(parseISO(value), 'dd.MM.yyyy') : null
        }
      },
      immediate: true
    }
  },
  methods: {
    focusOutHandler() {
      this.isFieldInFocus = false

      if(this.inpValue) {
        const curDate = format(new Date(), 'dd.MM.yyyy')
        curDate.slice(0, this.inpValue.length)
        let newDate = this.inpValue + curDate.slice( this.inpValue.length)
        const dateArr = newDate.split('.').reverse()
        const year = dateArr[0]
        if(Number(year) < this.vCalendarOptions.minDate.getFullYear()){
          dateArr[0] = this.vCalendarOptions.minDate.getFullYear()
        }

        newDate = dateArr.join('-')
        this.$emit('input', newDate)
      }
    },
    inputHandler(event){
      this.inpValue = event.target.value
      if(!this.inpValue) {
        this.$emit('input', null)
      }
      if(this.inpValue.length === 10) {
        const newDate = this.inpValue.split('.').reverse().join('-')
        this.$emit('input', newDate)
      }
    },
    emitInput(value) {
      if(!this.isFieldInFocus) {
        const newDate = value ? format(value, 'yyyy-MM-dd') : null
        this.$emit('input', newDate)
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/components/inputs/PcDateInput.scss"
</style>
